<template>
  <main-template>
    <v-row>
      <v-col>
        <span class="text-h4">
          {{ isAprovador ? "Solicitações de Autorização" : "Meus Pedidos de Autorização" }}
        </span>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="pt-0 pb-0">
        <div class="d-flex mb-2 justify-end">
          <v-text-field
            v-model="search"
            class="ml-2 search-input"
            append-icon="mdi-magnify"
            label="Pesquisar..."
            solo
            dense
            single-line
            hide-details
          />
        </div>
      </v-col>
      <v-col class="pt-0">
        <v-data-table
          :headers="headersComputados"
          :items="autorizacoesList"
          :loading="carregandoAutorizacoes"
          :items-per-page="10"
          :custom-filter="dataTableFilter"
          :search="search"
          class="elevation-1"
        >
          <template v-slot:body="{ items }">
            <tbody name="scroll-x-transition" is="transition-group" duration="150">
              <tr
                v-for="(autorizacao, i) of items"
                :key="i"
                style="cursor: pointer"
                @click="() => tentarAbrirDialog(autorizacao)"
              >
                <td>{{ autorizacao.id }}</td>
                <td>{{ autorizacao.pedido ? autorizacao.pedido.descricao : "- - -" }}</td>
                <td>{{ autorizacao.solicitante ? autorizacao.solicitante.name : "- - -" }}</td>
                <td>{{ autorizacao.etapa ? autorizacao.etapa.descricao : "- - -" }}</td>
                <td>
                  <v-chip label x-small :color="mudarCor(autorizacao.status)">
                    {{ autorizacao.status }}
                  </v-chip>
                </td>
                <td>
                  {{
                    autorizacao.data_expiracao
                      ? validarData(autorizacao.data_expiracao)
                      : "Indeterminado"
                  }}
                </td>
                <td>
                  {{ autorizacao.created_at ? validarData(autorizacao.created_at) : "- - -" }}
                </td>
                <td v-if="isAprovador">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="blue-grey lighten-3"
                        v-bind="attrs"
                        v-on="on"
                        @click.stop="abrirDialogAprovador(autorizacao)"
                      >
                        <v-icon small>fa fa-edit</v-icon>
                      </v-btn>
                    </template>
                    <span>Analisar solicitacao</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-- Modal do aprovador -->
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="680px">
        <v-card v-if="autorizacaoSelecionada">
          <v-card-title class="primary">
            <span style="color: #fff" class="text-h5">
              Analisar Solicitacao #{{ autorizacaoSelecionada.id }}
            </span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <v-row class="pt-4">
                <v-col class="pt-0 pb-0" cols="12" sm="6">
                  <e-label class="font-weight-medium">Solicitante</e-label>
                  <p class="font-weight-regular">
                    {{
                      autorizacaoSelecionada.solicitante
                        ? autorizacaoSelecionada.solicitante.name
                        : "- - -"
                    }}
                  </p>
                </v-col>
                <v-col class="pt-0 pb-0" cols="12" sm="6">
                  <e-label class="font-weight-medium">Tipo</e-label>
                  <p class="font-weight-regular">
                    {{
                      autorizacaoSelecionada.pedido
                        ? autorizacaoSelecionada.pedido.descricao
                        : "- - -"
                    }}
                  </p>
                </v-col>
                <v-col class="pt-0 pb-0" cols="12" sm="6">
                  <e-label class="font-weight-medium">Etapa/Periodo</e-label>
                  <p class="font-weight-regular">
                    {{
                      autorizacaoSelecionada.etapa
                        ? autorizacaoSelecionada.etapa.descricao
                        : "- - -"
                    }}
                  </p>
                </v-col>
                <v-col class="pt-0 pb-0" cols="12" sm="6">
                  <e-label class="font-weight-medium">Data da solicitacao</e-label>
                  <p class="font-weight-regular">
                    {{
                      autorizacaoSelecionada.created_at
                        ? validarData(autorizacaoSelecionada.created_at)
                        : "- - -"
                    }}
                  </p>
                </v-col>
                <v-col class="pt-0 pb-0" cols="12">
                  <e-label class="font-weight-medium">Observacao do solicitante</e-label>
                  <p class="font-weight-regular">
                    {{ autorizacaoSelecionada.observacoes || "Nenhuma observacao informada." }}
                  </p>
                </v-col>
              </v-row>

              <v-divider class="my-4"></v-divider>

              <ValidationObserver ref="obsAprovador" v-slot="{ handleSubmit }">
                <form @submit.prevent="handleSubmit(submitForm)">
                  <v-row>
                    <v-col class="pt-0 pb-0" cols="12" sm="6">
                      <ValidationProvider name="Situacao" rules="required" v-slot="{ errors }">
                        <e-label>Situacao <span class="red--text">*</span></e-label>
                        <v-select
                          v-model="novoStatus"
                          :items="$constants.situacaoAutorizacao"
                          :error-messages="errors"
                          dense
                          solo
                        />
                      </ValidationProvider>
                    </v-col>

                    <v-col class="pt-0 pb-0" cols="12" sm="6">
                      <ValidationProvider
                        name="Data de Expiracao"
                        :rules="novoStatus === 'APROVADO' ? 'required' : ''"
                        v-slot="{ errors }"
                      >
                        <e-label>
                          Data de Expiracao
                          <span v-if="novoStatus === 'APROVADO'" class="red--text">*</span>
                        </e-label>

                        <v-dialog
                          ref="dialogData"
                          v-model="modalData"
                          :return-value.sync="data_expiracao"
                          persistent
                          width="290px"
                          :retain-focus="false"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="periodo_expiracao"
                              label="Escolha uma data"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              dense
                              solo
                              :error-messages="errors"
                              clearable
                              @click:clear="limparDataExpiracao"
                            />
                          </template>
                          <v-date-picker v-model="data_expiracao" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="modalData = false">Cancelar</v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.dialogData.save(data_expiracao)"
                              >OK</v-btn
                            >
                          </v-date-picker>
                        </v-dialog>
                      </ValidationProvider>
                    </v-col>

                    <v-col class="pt-0 pb-0" cols="12">
                      <e-label>Observacao do Aprovador (opcional)</e-label>
                      <v-textarea
                        v-model="observacoesAprovador"
                        solo
                        dense
                        placeholder="Adicione uma observacao ou justificativa..."
                        rows="2"
                      />
                    </v-col>
                  </v-row>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      style="color: #fff"
                      class="red darken-1"
                      type="button"
                      :disabled="submittingForm"
                      @click="fecharDialog"
                    >
                      Fechar
                    </v-btn>
                    <v-btn
                      style="color: #fff"
                      class="green darken-1"
                      type="submit"
                      :loading="submittingForm"
                      :disabled="submittingForm || (novoStatus === 'APROVADO' && !data_expiracao)"
                    >
                      Salvar
                    </v-btn>
                  </v-card-actions>
                </form>
              </ValidationObserver>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Modal de detalhes para o solicitante (somente leitura) -->
    <v-row justify="center">
      <v-dialog v-model="dialogSolicitante" max-width="560px">
        <v-card v-if="autorizacaoSelecionada">
          <v-card-title class="primary">
            <span style="color: #fff" class="text-h5">
              Detalhes do Pedido #{{ autorizacaoSelecionada.id }}
            </span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <v-row class="pt-4">
                <v-col class="pt-0 pb-0" cols="12">
                  <e-label class="font-weight-medium">Tipo</e-label>
                  <p class="font-weight-regular">
                    {{
                      autorizacaoSelecionada.pedido
                        ? autorizacaoSelecionada.pedido.descricao
                        : "- - -"
                    }}
                  </p>
                </v-col>
                <v-col class="pt-0 pb-0" cols="12" sm="6">
                  <e-label class="font-weight-medium">Etapa</e-label>
                  <p class="font-weight-regular">
                    {{
                      autorizacaoSelecionada.etapa
                        ? autorizacaoSelecionada.etapa.descricao
                        : "- - -"
                    }}
                  </p>
                </v-col>
                <v-col class="pt-0 pb-0" cols="12" sm="6">
                  <e-label class="font-weight-medium">Data da solicitacao</e-label>
                  <p class="font-weight-regular">
                    {{
                      autorizacaoSelecionada.created_at
                        ? validarData(autorizacaoSelecionada.created_at)
                        : "- - -"
                    }}
                  </p>
                </v-col>
                <v-col class="pt-0 pb-0" cols="12" sm="6">
                  <e-label class="font-weight-medium">Situacao</e-label>
                  <p class="font-weight-regular">
                    <v-chip label x-small :color="mudarCor(autorizacaoSelecionada.status)">
                      {{ autorizacaoSelecionada.status }}
                    </v-chip>
                  </p>
                </v-col>
                <v-col class="pt-0 pb-0" cols="12" sm="6">
                  <e-label class="font-weight-medium">Validade</e-label>
                  <p class="font-weight-regular">
                    {{
                      autorizacaoSelecionada.data_expiracao
                        ? validarData(autorizacaoSelecionada.data_expiracao)
                        : "Indeterminado"
                    }}
                  </p>
                </v-col>
                <v-col class="pt-0 pb-0" cols="12">
                  <e-label class="font-weight-medium">Sua observacao</e-label>
                  <p class="font-weight-regular">
                    {{ autorizacaoSelecionada.observacoes || "- - -" }}
                  </p>
                </v-col>
                <v-col
                  class="pt-0 pb-0"
                  cols="12"
                  v-if="autorizacaoSelecionada.observacoes_aprovador"
                >
                  <e-label class="font-weight-medium">Resposta do aprovador</e-label>
                  <p class="font-weight-regular">
                    {{ autorizacaoSelecionada.observacoes_aprovador }}
                  </p>
                </v-col>
              </v-row>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn style="color: #fff" class="red darken-1" @click="dialogSolicitante = false">
                  Fechar
                </v-btn>
              </v-card-actions>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import { dataTableFilter } from "@/plugins/searchQuery";
import ELabel from "../../../components/ELabel.vue";

export default {
  components: { ELabel },

  computed: {
    ...mapGetters("Autorizacoes", ["autorizacoes", "carregandoAutorizacoes", "autorizacoesList"]),

    isAprovador() {
      return !!this.currentUser.permissao_especial;
    },

    headersComputados() {
      const base = [
        { text: "#", value: "id" },
        { text: "Tipo de Solicitação", value: "descricao" },
        { text: "Solicitante", value: "solicitante" },
        { text: "Etapa/Período", value: "etapa" },
        { text: "Situação", value: "status" },
        { text: "Validade", value: "data_expiracao" },
        { text: "Data Solicitação", value: "created_at" },
      ];
      if (this.isAprovador) {
        base.push({ text: "Ações", value: "acoes", sortable: false });
      }
      return base;
    },
  },

  data() {
    return {
      data_expiracao: null,
      periodo_expiracao: null,
      novoStatus: null,
      observacoesAprovador: null,
      modalData: false,
      dialog: false,
      dialogSolicitante: false,
      autorizacaoSelecionada: null,
      submittingForm: false,
      dataTableFilter,
      search: "",
      currentUser: store.getters["Auth/user"],
    };
  },

  mounted() {
    if (this.isAprovador) {
      this.$store.dispatch("Autorizacoes/loadAutorizacoes", { tipo: "aprovador" });
    } else {
      this.$store.dispatch("Autorizacoes/loadAutorizacoes", { tipo: "solicitante" });
    }
  },

  watch: {
    carregandoAutorizacoes(value) {
      if (value) {
        this.$loaderService.open("Carregando autorizações...");
      } else {
        this.$loaderService.close();
      }
    },
    data_expiracao(value) {
      if (!value) {
        this.periodo_expiracao = null;
        return;
      }
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(
        new Date(value)
      );
      this.periodo_expiracao = data_old;
    },
    novoStatus() {
      this.$nextTick(() => {
        if (this.$refs.obsAprovador) this.$refs.obsAprovador.validate();
      });
    },
  },

  methods: {
    mudarCor(status) {
      switch (status) {
        case "PENDENTE":
          return "warning";
        case "APROVADO":
          return "green";
        case "RECUSADO":
          return "red";
        default:
          return "grey";
      }
    },

    tentarAbrirDialog(item) {
      this.autorizacaoSelecionada = item;
      if (this.isAprovador) {
        this.abrirDialogAprovador(item);
      } else {
        this.dialogSolicitante = true;
      }
    },

    abrirDialogAprovador(item) {
      this.autorizacaoSelecionada = item;
      this.novoStatus = item.status;
      this.observacoesAprovador = item.observacoes_aprovador || null;
      this.data_expiracao = item.data_expiracao || null;
      this.dialog = true;
    },

    fecharDialog() {
      this.dialog = false;
      this.autorizacaoSelecionada = null;
      this.novoStatus = null;
      this.data_expiracao = null;
      this.periodo_expiracao = null;
      this.observacoesAprovador = null;
      if (this.$refs.obsAprovador) this.$refs.obsAprovador.reset();
    },

    limparDataExpiracao() {
      this.data_expiracao = null;
      this.periodo_expiracao = null;
    },

    validarData(data) {
      if (!data) return "—";
      const date = new Date(data);
      if (isNaN(date.getTime())) return data;
      return new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(date);
    },

    async submitForm() {
      const valid = await this.$refs.obsAprovador.validate();
      if (!valid) return;

      this.submittingForm = true;
      try {
        await this.$services.autorizacoesService.atualizarAutorizacao({
          id: this.autorizacaoSelecionada.id,
          status: this.novoStatus,
          data_expiracao: this.data_expiracao,
          observacoes_aprovador: this.observacoesAprovador,
          user_aprovador: this.currentUser.id,
        });
        this.$toast.success("Pedido atualizado com sucesso!");
        this.fecharDialog();
        this.$store.dispatch("Autorizacoes/loadAutorizacoes");
      } catch (error) {
        this.$handleError(error);
      }
      this.submittingForm = false;
    },
  },
};
</script>

<style></style>
